/** Track whether this is the user's first time launching the app. */

const FIRST_RUN_KEY = "dd-first-run-complete";

/** Returns true if the user has never completed the first-run wizard. */
export function isFirstRun(): boolean {
  return localStorage.getItem(FIRST_RUN_KEY) === null;
}

/** Mark the first-run wizard as complete so it won't show again. */
export function markFirstRunComplete(): void {
  localStorage.setItem(FIRST_RUN_KEY, "true");
}

/** Clear the first-run flag so the wizard shows again on next load. */
export function clearFirstRun(): void {
  localStorage.removeItem(FIRST_RUN_KEY);
}
